import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";
import {
  CREATE_AUDIT_VOUCHER_SUCCESS,
  FETCH_AUDIT_VOUCHER_SUCCESS,
  GET_AUDIT_VOUCHER_SEARCH_END,
  GET_AUDIT_VOUCHER_SEARCH_START,
  GET_AUDIT_VOUCHER_SEARCH_SUCCESS,
  GET_AUDIT_VOUCHER_SUCCESS,
  SAVE_AUDIT_VOUCHER_QUERY
} from "../../constants/ActionTypes";
import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_AUDIT_VOUCHER_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_AUDIT_VOUCHER_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_AUDIT_VOUCHER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_AUDIT_VOUCHER_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { assetMake } = store.getState();
      const { query } = assetMake;
      const response = await axios.get(`/audit-voucher?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { assetMake } = store.getState();
      const { query } = assetMake;
      const response = await axios.get(`/audit-voucher/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/audit-voucher`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
      }
      if (!redirect) {
        if (subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if (superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/audit-voucher');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/audit-voucher/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/audit-voucher');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/audit-voucher/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.delete(`/audit-voucher/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const searchAuditVoucher = (keyword = '') => {
  return async dispatch => {
    try {
      // console.log(keyword);
      dispatch(fetchSearchAuditVoucherStart());
      // console.log(keyword);
      const response = await axios.get(`/audit-voucher/search/${keyword.toLowerCase().replace(/\//g, '=')}`);
      // console.log(response.data);
      const { data } = response;
      dispatch(getSearchAuditVoucherSuccess(data));
      dispatch(fetchSearchAuditVoucherEnd());
    } catch (error) {
      dispatch(fetchSearchAuditVoucherEnd());
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const getSearchAuditVoucherSuccess = (data) => {
  return {
    type: GET_AUDIT_VOUCHER_SEARCH_SUCCESS,
    data
  };
};

export const fetchSearchAuditVoucherStart = () => {
  return {
    type: GET_AUDIT_VOUCHER_SEARCH_START
  }
};

export const fetchSearchAuditVoucherEnd = () => {
  return {
    type: GET_AUDIT_VOUCHER_SEARCH_END
  }
};